/*
    This Service is used to trigger modal events that are necessay for the website.
*/
import { EventEmitter, Output, Injectable } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import * as _ from 'underscore';

import { WcuObjectUtility } from '../utilities/object.untility';

@Injectable()
export class FormUtilityService {
    dataChangeEvent: EventEmitter<any> = new EventEmitter();

    constructor(private objectHelper: WcuObjectUtility) { }

    dataChange(data: any) {
        this.dataChangeEvent.emit(data);
    }

    handleSubmit(successCallBack:() => void, errorCallBack:() => void, data:any) {
        let status = this.objectHelper.validateObj(data, 'form.status', '');
        if (status === 'VALID') {
            successCallBack();
        } else if (status === 'INVALID') {
            errorCallBack();
        }
    }

    validateAllFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
                control.markAsDirty({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFields(control);
            }
        });
    }

    generateFormControls(config:Array<any>, inputControls:any) {
        let ctx = this;
        try {
            _.each(config, function(inputList, index, list){
                _.each(inputList, function(input, key, inputLst){
                    let validations = ctx.objectHelper.validateObj(input, 'validation', [])
                    let name = ctx.objectHelper.validateObj(input, 'name', '');
                    if (name) {
                        inputControls[name] = new FormControl('', Validators.compose(validations));
                    } else {
                        inputControls[key] = new FormControl('', Validators.compose(validations));
                    }
                });
            });
        } catch(e) {
            console.log({
                exception: e,
                method: 'generateFormControls',
                servie: 'form-uitlity'
            });
        }
    }
}
